export const servicesCatalogSelector = state => state.servicesCatalog;
